<template>
  <div>
    <div v-if="model===false">
      <div ref="total" class="totalmakeHole">
        <div class="makeHole1">
          <div :style="{ height: '6vh', backgroundColor: scrollback ? 'rgb(245 244 246)' : 'rgb(245 244 246)' ,position:'fixed'}"
               class="topback">
            <headtip  :changeVisable="changeVisable" @showDialog="showPartner"></headtip>
          </div>
          <div @click="changeheadVisable">
            <kefu @toptop="topTop"></kefu>
            <Anxunheader
              :title1="'Smart Wellbore'"
              :title2="'Support single-well production management through real-time acquisition of downhole production parameters, wellbore condition monitoring, and intelligent analytics, enabling real-time awareness and optimization of well operations.'"
              @clickConsult1="clickConsult('Oil & Gas Generic AI')"
            ></Anxunheader>
            <div  class="screenmake3" style="background-color: white">
              <div v-sliden-in="{duration:800}" class="heighLight" >
                Customer Benefits
              </div>
              <div class="grid" style="margin-top: 2vh">
                <image-up-text-down v-sliden-in="{duration:800 + 400*index}" v-for="(elemnt,index) in yourBenfits" :key="elemnt.title1"  :imagepath="require('@/assets'+elemnt.imagepath)" :title1="elemnt.title1" :title2="elemnt.title2"></image-up-text-down>
            </div>
            </div>
            <div class="screenmake8" style="background-color: transparent">
              <div v-sliden-in="{duration:800}" class="heighLight"> Key Challenges & Pain Points</div>
              <div v-sliden-in="{duration:800}" class="grid">
                <div v-for="item in painPoints" :key="item.title" class="card">
                  <div class="back">
                    <div class="imgDesign">
                      <img loading="lazy" :src="item.img" style="border-radius: 9px">
                    </div>
                    <div class="titleDesign">
                      <div class="title1">{{ item.title }}</div>
                      <div class="title2">{{ item.desc }}</div>
                    </div>
                  </div>
                </div>

              </div>

            </div>
            <!-- <div class="screenmake1" style="background-color: transparent">
              <div v-sliden-in="{duration:800}" class="heighLight"> 方案架构</div>
              <div v-sliden-in="{duration:800}" class="grid">
                <div class="card">
                  <div class="back">
                    <div class="imgDesign">
                      <el-tooltip class="item" content="点击放大，看得更清晰！" effect="dark" placement="top">
                        <img loading="lazy" src="@/assets/storageConstruct.png"
                             style="border-radius: 9px" @click="showModalTrue(require('@/assets/storageConstruct.png'))">
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
            <div class="screenmake5" style="background-color: white">
              <div v-sliden-in="{ duration: 800 }" class="heighLight">
                Core Value
              </div>
              <div v-sliden-in="{ duration: 800 }" class="grid">
                <div class="card" v-for="item in coreFunctions" :key="item.key">
                  <div class="back">

                    <div class="titleDesign">
                      <div class="title1">{{ item.title }}</div>
                      <div class="title2">
                        <li v-for="(point, i) in item.points" :key="i">{{ point }}</li>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div class="screenmake2"  style="background-color: transparent">
              <div v-sliden-in="{duration:800}" class="heighLight">Technical Highlights</div>
              <div v-sliden-in="{duration:800}" class="grid">
                <div v-for="item in techFeatures" :key="item.key" class="card">
                  <div class="back">
                    <div class="imgDesign" :style="item.imgStyle">
                      <img loading="lazy" :src="item.img" style="border-radius: 9px">
                    </div>
                    <div class="titleDesign">
                      <div class="title1">{{ item.title }}</div>
                      <div class="title2" v-if="item.points">
                        <ul class="tech-points-sublist">
                          <li v-for="(point, i) in item.points" :key="i">{{ point }}</li>
                        </ul>
                      </div>
                      <div class="title2" v-else>{{ item.desc }}</div>
                    </div>
                  </div>
                </div>
              </div>

            </div>


            <div class="screenmake22" style="background-color: white">
                <div v-sliden-in="{ duration: 800 }" class="heighLight">
                    Service Capabilities</div>
                <div v-sliden-in="{ duration: 800 }" class="grid">
                    <div v-for="(item, index) in serviceCapabilities" :key="index" class="card">
                        <div class="back">
                            <div class="titleDesign">
                                <div class="title1">{{ item.title1 }}</div>
                                <div class="title2">
                                    <li v-for="(line, i) in item.title2Items" :key="i">{{ line }}</li>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="screenmake4">
                <div v-sliden-in="{ duration: 800 }" class="heighLight">成功案例</div>
                <div class="grid">
                    <el-carousel indicator-position="outside" arrow="always" interval="5000">
                        <el-carousel-item v-for="item in success" :key="item">
                            <div class="card">
                                <div class="back">
                                    <div v-left-in="{ duration: 800 }" class="imgDesign">
                                        <el-tooltip class="item" effect="dark" content="点击放大，看得更清晰！"
                                            placement="top">
                                            <img loading="lazy" @click="showModalTrue(item.img)"
                                                :src="item.img" />

                                        </el-tooltip>
                                    </div>
                                    <div v-sliden-in="{ duration: 800 }" class="titleDesign">
                                        <div class="title1">{{ item.title1 }}</div>
                                        <div class="title2" v-html="item.title2"></div>
                                    </div>
                                </div>


                            </div>


                        </el-carousel-item>
                    </el-carousel>
                </div>

            </div>

            <bottomTip></bottomTip></div>
        </div>
        <div v-if="showModal" class="modal-overlay" @click="closeModal">
          <div class="modal-content">
            <img :src="largeSrc" alt="Large Image" class="large-image">
          </div>
        </div>
        <partnerTip
            :dialogVisible="dialogconsult"
            @hideDialog="hide"
        ></partnerTip>
        <consultTip
            :dialogVisible="dialogVisible"
            :thisTitle="title"
            @hideDialog="hideDialog"
        ></consultTip>
      </div>
    </div>
    <div v-else>
      <div class="totalmakeHoleModel"  ref="totalModel">
        <div class="makeHole1">
          <div class="screen1">
            <kefuMobile @topMobile="topTopmobile"></kefuMobile>
            <headtip  :changeVisable="changeVisable" @showDialog="showPartner"></headtip>
            <div class="layer2">
              <div v-sliden-instep="{duration:800}" class="title1"><img loading="lazy" src="@/assets/AnxunLogo.png"></div>
              <div v-sliden-instep="{duration:1600}" class="title2" style="font-weight: bolder;font-size: 25px;margin-top: 15px;line-height: 30px;color:#F44336">
                Smart Wellbore Solutions
              </div>
              <div v-sliden-instep="{duration:1600}" class="title2" style="font-weight: bolder;margin-top: 15px;font-size: 18px;line-height: 28px;color:#2c3e50;text-align: left">
                Address the management of single-well production in oil and gas by real-time collection of wellbore production parameters, monitoring of wellbore operating conditions, and intelligent analysis to achieve real-time awareness and intelligent optimization of wellbore production processes.
              </div>
            </div>
            <div style="position: absolute;bottom: 30px;left: 50%;transform:translateX(-50%);">
              <div v-sliden-instep="{duration:2400}" class="title4" style="font-weight: bolder;font-size: 18px;line-height: 28px;padding-bottom: 5px;color: #2f6dfd;">Oil & Gas Digital Intelligence, Simple and Easy</div>
              <div class="titlle3" @click="clickConsult('Oil & Gas Generic AI')">
                Product Inquiry
              </div>
            </div>
            <div class="layer3"></div>
          </div>
          <div class="screenmake111">
            <div v-sliden-in="{duration:800}" class="heighLight" >Customer Value</div>
            <div class="grid">
              <image-up-text-down-mobile v-for="elemnt in yourBenfits" :key="elemnt.title1"  :imagepath="require('@/assets'+elemnt.imagepath)" :title1="elemnt.title1" :title2="elemnt.title2"></image-up-text-down-mobile>
            </div>
          </div>
          <div class="screenmake5" style="padding-top: 20px">
            <div v-sliden-in="{duration:800}" class="heighLight"> Key Challenges & Pain Points</div>
            <div class="grid">
              <div
                v-for="(item, index) in painPoints"
                :key="item.title"
                v-sliden-in="{duration:800}"
                class="card"
                :style="index === 0 ? 'margin-top: 10px' : ''"
              >
                <div class="back">
                  <div class="imgDesign">
                    <img loading="lazy" :src="item.img" style="border-radius: 9px">
                  </div>
                  <div class="titleDesign">
                    <div class="title1">{{ item.title }}</div>
                    <div class="title2">{{ item.desc }}</div>
                  </div>
                </div>
              </div>


            </div>

          </div>
          <!-- <div class="screenmake1" style="padding-top: 20px">
            <div v-sliden-in="{duration:800}" class="heighLight"> 方案架构</div>
            <div class="grid">
              <div v-sliden-in="{duration:800}" class="card">
                <div class="back">
                  <div class="imgDesign">
                    <img loading="lazy" src="@/assets/storageConstruct.png" style="border-radius: 9px">
                  </div>
                </div>
              </div>
            </div>

          </div> -->
          <div class="screenmake6">
            <div v-sliden-in="{duration:800}" class="heighLight">Core Value</div>
            <div class="grid">
              <div v-sliden-in="{duration:800}" class="card card--core-points">
                <div class="back" style="background-color: white;box-shadow: none">
                  <ul class="core-points-list">
                    <li v-for="(item, idx) in coreFunctions" :key="item.key" class="core-point-item">
                      <div class="core-point-title">{{ idx + 1 }}. {{ item.title }}</div>
                      <ul class="core-point-sublist">
                        <li v-for="(point, i) in item.points" :key="i">{{ point }}</li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="screenmake2"  style="background-color: transparent">
            <div v-sliden-in="{duration:800}" class="heighLight">Technical Highlights</div>
            <div class="grid">
              <div v-for="item in techFeaturesMobile" :key="item.key" v-sliden-in="{duration:800}" class="card">
                <div class="back">
                  <div class="imgDesign" :style="item.imgBoxStyle">
                    <img loading="lazy" :src="item.img" :style="item.imgStyle" style="border-radius: 9px">
                  </div>
                  <div class="titleDesign">
                    <div class="title1">{{ item.title }}</div>
                    <div class="title2">
                      {{ item.desc }}<br v-if="item.key === 'security'" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div class="screenmake22" style="background-color: white">
                <div v-sliden-in="{ duration: 800 }" class="heighLight">
                    Service Capabilities</div>
                <div v-sliden-in="{ duration: 800 }" class="grid">
                    <div v-for="(item, index) in serviceCapabilities" :key="index" class="card">
                        <div class="back">
                            <div class="titleDesign">
                                <div class="title1">{{ item.title1 }}</div>
                                <div class="title2">
                                    <li v-for="(line, i) in item.title2Items" :key="i">{{ line }}</li>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
          <div class="screenmake4">
            <div v-sliden-in="{ duration: 800 }" class="heighLight">Success Cases</div>
            <div v-sliden-in="{ duration: 800 }" class="grid">
                <el-carousel indicator-position="outside" arrow="always" interval="5000">
                    <el-carousel-item v-for="item in success" :key="item">
                        <div class="card">
                            <div class="back">
                                <div class="imgDesign">
                                    <img loading="lazy" :src="item.img" />
                                </div>
                                <div class="titleDesign">
                                    <div class="title1">{{ item.title1 }}</div>
                                    <div class="title2" v-html="item.title2"></div>
                                </div>
                            </div>


                        </div>


                    </el-carousel-item>
                </el-carousel>
            </div>

        </div>

          <div ref="bottom">
            <bottomTip></bottomTip>
          </div>
        </div>
        <partnerTip
            :dialogVisible="dialogconsult"
            @hideDialog="hide"
        ></partnerTip>
        <consultTip
            :dialogVisible="dialogVisible"
            :thisTitle="title"
            @hideDialog="hideDialog"
        ></consultTip>
      </div>
    </div>
  </div>


</template>


<script>

import headtip from "@/views/headTip.vue";
import bottomTip from "@/views/bottomTip.vue";
import consultTip from "@/components/consultTip.vue";
import PartnerTip from "@/components/partnerTip.vue";
import {shareUrl} from "@/utils/vxshare";
import kefuMobile from "@/views/kefuMobile.vue";
import kefu from "@/views/kefu.vue";
import {vSlidenIn} from "@/utils/vSlidenIn";
import {vZoomIn} from "@/utils/vZoomIn";
import {vSlidenInstep} from "@/utils/vSlidenInstep";
import {vLeftIn} from "@/utils/vLeftIn";
import Anxunheader from "@/views/Anxun/component/Anxunheader.vue";
import ImageUpTextDown from "@/views/component/imageUpTextDown.vue";
import ImageUpTextDownMobile from "@/views/component/imageUpTextDownMobile.vue";
export default {
  directives: {
    slidenIn: vSlidenIn,
    zoomIn: vZoomIn,
    slidenInstep:vSlidenInstep,
    leftIn:vLeftIn
  },
  name: "IntelligentReservoir",

  props: [],

  components: {
    ImageUpTextDownMobile,
    ImageUpTextDown, Anxunheader,PartnerTip, consultTip, headtip, bottomTip,kefu,kefuMobile},

  data() {
    return {
      yourBenfits:[
        {
          imagepath:'/guidance14.png',
          title1:'Increase Single-Well Production',
          title2:'Optimize production strategies through real-time monitoring and intelligent analysis of wellbore production status to enhance output.'
        },       {
          imagepath:'/storagebenefit2.png',
          title1:'Reduce Wellbore Failure Risks',
          title2:'Identify anomalies through real-time monitoring of wellbore conditions to detect issues early and reduce downtime risks.'
        },       {
          imagepath:'/storagebenefit3.png',
          title1:'Improve Artificial Lift Efficiency',
          title2:'Analyze the operational status of artificial lift systems such as ESP and rod pumps to optimize lifting parameters.'
        },       {
          imagepath:'/guanwang3.png',
          title1:'Enable Intelligent Single-Well Management',
          title2:'Achieve unified data management and enable visualization and intelligent decision-making for single-well operations.'
        },
      ],
      painPoints: [
        {
          img: require('@/assets/product02.png'),
          title: 'Limited Real-time Visibility of Wellbore Conditions',
          desc: 'Downhole production data acquisition remains challenging, resulting in limited comprehensive visibility of wellbore operating conditions in real time.',
        },
        {
          img: require('@/assets/smartstation22.png'),
          title: 'Low Efficiency of Artificial Lift Systems',
          desc: 'The lack of intelligent analytics for artificial lift equipment operating parameters makes it difficult to optimize lifting efficiency.',
        },
        {
          img: require('@/assets/product01.png'),
          title: 'Delayed Detection of Wellbore Abnormalities',
          desc: 'Issues such as wax deposition, gas locking, and sand plugging are difficult to detect in a timely manner, impacting production stability.',
        },
        {
          img: require('@/assets/storage02.png'),
          title: 'Low Utilization of Single-well Production Data',
          desc: 'Production data is fragmented and lacks a unified analytics platform, limiting its ability to support production optimization and data-driven decision-making.',
        },
      ],
      coreFunctions: [
        {
          key: 'monitor',
          title: 'Wellbore Production Monitoring',
          points: [
            'Downhole pressure monitoring',
            'Downhole temperature monitoring',
            'Wellhead pressure monitoring',
            'Flow rate monitoring',
            'Water cut monitoring',
          ],
        },
        {
          key: 'alarm',
          title: 'Artificial Lift Management',
          points: [
            'ESP operating status monitoring',
            'Beam pump operation monitoring',
            'Gas lift system monitoring',
            'Lift efficiency analysis',
          ],
        },
        {
          key: 'modeling',
          title: 'Wellbore Abnormality Diagnosis',
          points: [
            'Gas lock detection',
            'Wax deposition detection',
            'Sand plugging detection',
            'Production anomaly analysis',
          ],
        },
        {
          key: 'optimize',
          title: 'Wellbore Production Optimization',
          points: [
            'Production strategy optimization',
            'Lift parameter optimization',
            'Single-well production forecasting',
            'Injection-production parameter optimization',
          ],
        },
        {
          key: 'integrity',
          title: 'Wellbore Integrity Management',
          points: [
            'Casing pressure monitoring',
            'Wellbore corrosion monitoring',
            'Wellbore leakage risk identification',
          ],
        },
      ],
      techFeatures: [
        {
          key: 'sensor',
          img: require('@/assets/monitor02.png'),
          imgStyle: { width: '12vh' },
          title: 'Wellbore Production Monitoring Technology',
          desc: 'By integrating downhole sensors with surface data acquisition systems, the solution enables real-time collection of wellbore production parameters.',
        },
        {
          key: 'cloudEdge',
          img: require('@/assets/guanwang2.png'),
          title: 'Production Data Analytics Technology',
          desc: 'Leveraging advanced data analytics models, the solution enables wellbore condition identification and abnormality diagnosis.',
        },
        {
          key: 'security',
          img: require('@/assets/storage01.png'),
          title: 'Artificial Lift Optimization Technology',
          desc: 'Through analysis of artificial lift system operating data, the solution optimizes the performance of ESP, beam pumps, and gas lift systems—enhancing overall lifting efficiency.',
        },
        {
          key: 'modular',
          img: require('@/assets/news112.png'),
          title: 'AI-driven Production Optimization Algorithms',
          desc: 'By applying artificial intelligence algorithms, the solution enables single-well production forecasting and production strategy optimization.',
        },
      ],
      techFeaturesMobile: [
        {
          key: 'sensor',
          img: require('@/assets/monitor02.png'),
          imgStyle: { width: '8vh' },
          title: 'Wellbore Production Monitoring Technology',
          desc: 'By integrating downhole sensors with surface data acquisition systems, the solution enables real-time collection of wellbore production parameters.',
        },
        {
          key: 'cloudEdge',
          img: require('@/assets/guanwang2.png'),
          title: 'Production Data Analytics Technology',
          desc: 'Leveraging advanced data analytics models, the solution enables wellbore condition identification and abnormality diagnosis.',
        },
        {
          key: 'security',
          img: require('@/assets/storage01.png'),
          title: 'Artificial Lift Optimization Technology',
          desc: 'Through analysis of artificial lift system operating data, the solution optimizes the performance of ESP, beam pumps, and gas lift systems—enhancing overall lifting efficiency.',
        },
        {
          key: 'modular',
          img: require('@/assets/news112.png'),
          title: 'AI-driven Production Optimization Algorithms',
          desc: 'By applying artificial intelligence algorithms, the solution enables single-well production forecasting and production strategy optimization.',
        },
      ],
      serviceCapabilities: [
        {
          title1: 'Wellbore Monitoring System Deployment',
          title2Items: [
            'Deployment of wellbore monitoring equipment',
            'Implementation of data acquisition systems',
            'Development of wellbore monitoring platforms',
          ],
        },
        {
          title1: 'Wellbore Production Optimization Services',
          title2Items: [
            'Single-well production analysis',
            'Design of production optimization strategies',
            'Production data analytics',
          ],
        },
        {
          title1: 'System Integration & Implementation',
          title2Items: [
            'Integration of wellbore monitoring equipment',
            'Integration of production management systems',
            'Development of wellbore data platforms',
          ],
        },
        {
          title1: 'Operations & Maintenance and Technical Support',
          title2Items: [
            'Wellbore system operation and maintenance',
            'System upgrade and optimization',
            'Technical training and support',
          ],
        },
      ],
      changeVisable:1,
      title: "",
      showModal: false,
      largeSrc: '',
      pageTitle: 'Smart Wellbore Solution_Anvision - Oil & Gas Communication GPT',
      pageDescription: 'Smart Wellbore Solution supports single-well production management through real-time acquisition of downhole production parameters, wellbore condition monitoring, and intelligent analytics, enabling real-time awareness and optimization of well operations.',
      pageKeywords: 'Smart Wellbore, Oil & Gas Production Management, Real-time Monitoring, Intelligent Analysis, Production Optimization, Anvision, Oil & Gas Communication GPT',
      scrollback: false,
      model: false,
      dialogconsult: false,
      dialogVisible: false,
      success: [{
        img: require("@/assets/ax-success/wellbore1.png"),
        title1: "CQ Oilfield Intelligent Tubing + ESP System",
        title2: "In CQ oilfield production scenarios, this solution integrates intelligent tubing with ESP (Electric Submersible Pump) technology to enable real-time downhole parameter sensing and intelligent control—improving oil production efficiency and enabling refined wellbore management.",
      },
      ]
    }

  },


  methods: {
    topTop() {
      this.$nextTick(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
    },
    topTopmobile() {
      this.topTop();
    },
    changeheadVisable(){
      this.changeVisable = this.changeVisable === 1 ? 0 : 1;
    },
    showModalTrue(item) {
      this.showModal = true;
      this.largeSrc = item
    },
    closeModal() {
      this.showModal = false;
    },
    clickConsult(item) {

      this.title = item
      this.dialogVisible = true;
      sessionStorage.setItem('title', item)
    },
    setMetaTags() {
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', this.pageDescription);
      }

      const metaKeywords = document.querySelector('meta[name="keywords"]');
      if (metaKeywords) {
        metaKeywords.setAttribute('content', this.pageKeywords);
      }
    },
    hide() {
      this.dialogconsult = false;
    },
    hideDialog() {
      this.dialogVisible = false;
    },
    showPartner() {
      this.dialogconsult = true;
    },
    skipp3() {
      const element = this.$refs.bottom;
      const rect = element.offsetTop + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0);

      this.$nextTick(() => {
        this.$refs.totalModel.scrollTop = rect
      });
    },
    handleScroll() {
      if (this.model === false) {
        this.scrollHeight = this.$refs.total.scrollTop;
      } else {
        this.scrollHeight = this.$refs.totalModel.scrollTop;
      }

      if (this.scrollHeight < 100) {
        this.scrollTrue = true
      } else {
        this.scrollTrue = false
      }
      if (this.scrollHeight < 500) {
        this.scrollback = false
      } else {
        this.scrollback = true
      }
    },
  },
  beforeDestroy() {

    this.$refs.total.removeEventListener('scroll', this.handleScroll);
  },
  mounted() {
    this.$refs.total.addEventListener('scroll', this.handleScroll);
    document.title = this.pageTitle;
    this.setMetaTags();
    const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    if (screenWidth <= 700) {
      this.model = true
    } else {
      this.model = false
    }

    if (localStorage.getItem("skip") === '3') {
      this.$nextTick(() => {
        this.skipp3();
      });
    }
  },
  created() {
    localStorage.setItem("home", 0)
    let url = window.location.href
    // let url = 'https://oilgasinfoai.com/?language=zh'
    setTimeout(() => {
      //encodeURIComponent 将你的URL进行转译一下，因为微信分享出去后会带有多余用不到的参数
      let shareData = {
        url: url,
        pageTitle: this.pageTitle,
        pageDescription: this.pageDescription,
        pageKeywords: this.pageKeywords,

      };
      shareUrl(shareData);
    }, 1000);
  },

}

</script>


<style lang="scss" scoped type="text/scss">
.totalmakeHole {
  background: #ebf1fd;
  overflow-x: hidden;
  height: auto;
  position: relative;

  .makeHole1 {
    //z-index:: 3;
    position: relative;
    width: 100%;
    //height: 100vh;

 .topback{
    position: fixed;
    z-index:999;
      width: 100vw;
      padding: 0 0 0 2.86077411900635vw;
    }

    //.screen1 {
    //  //z-index:: 3;
    //  position: relative;
    //  width: 100%;
    //  height: 63vh;
    //  padding: 0 2.86077411900635vw 2.84301606922126vh 2.86077411900635vw;
    //  background-image: url("../../assets/banner.png");
    //  background-position: center;
    //  background-size: cover;
    //  background-repeat: no-repeat;
    //  background-color: transparent;
    //  /* Add any additional styling as needed */
    //
    //  .layer2 {
    //    position: absolute;
    //    top: 10.1495673671199vh;
    //    left: 9.17157712305026vw;
    //    .title11{
    //      margin: 3.8207663782vh auto;
    //      font-size: 2vw;
    //    }
    //    .title1 {
    //      width: fit-content;
    //      height: 5.77626699629172vh;
    //      //font-size: 3.50606585788562vw;
    //      font-family: Sarial, sans-serif, "Microsoft Yahei";
    //      font-weight: 400;
    //      color: #2f6eff;
    //      //line-height: 12.23733003708282vh;
    //    }
    //
    //    .title2 {
    //      //margin-top: 6.82076637824475vh;
    //      width: 33.45869439630272vw;
    //      height: fit-content;
    //      font-size: 1.0597920277vw;
    //      font-family: Sarial, sans-serif, "Microsoft Yahei";
    //      font-weight: 400;
    //      color: black;
    //      line-height: 4.31520395550062vh;
    //    }
    //
    //    .title4 {
    //      height: 8.77626699629172vh;
    //      font-size: 1.6060658579vw;
    //      font-family: Sarial, sans-serif, "Microsoft Yahei";
    //      font-weight: 400;
    //      color: #2f6eff;
    //      line-height: 9.31520395550062vh;
    //    }
    //
    //    .titlle3 {
    //      margin-top: 2.07911001236094vh;
    //      cursor: pointer;
    //      display: flex;
    //      justify-content: center;
    //      align-items: center;
    //      font-size: 1vw;
    //      font-family: Sarial, sans-serif, "Microsoft Yahei";
    //      font-weight: 400;
    //      color: #ffffff;
    //      line-height: 3.3374536465vh;
    //      text-align: center;
    //      border-radius: 9.1px;
    //      width: fit-content;
    //      padding: 2.4624227441vh 1.1989601386vw;
    //      height: 4.5624227441vh;
    //      background: #2f6eff;
    //      border: #2f6eff 1px solid;
    //
    //    }
    //
    //    .titlle3:hover {
    //
    //      color: #2168DB;
    //      border: #2168DB 1px solid;
    //      background: rgba(255, 255, 255, 0.5);
    //    }
    //  }
    //
    //  //.layer3 {
    //  //  position: absolute;
    //  //  top: 5.06798516687268vh;
    //  //  right: 11.61178509532062vw;
    //  //  width: 47.42923165800116vw;
    //  //  height: 72.80593325092707vh;
    //  //  background-image: url("../assets/GPTplant.png");
    //  //  background-size: 100% auto;
    //  //  background-position: center;
    //  //  background-repeat: no-repeat;
    //  //  background-color: transparent;
    //  //  opacity: 1;
    //  //}
    //}

    .screenmake0 {
        padding: 5.78739184177998vh 8.09763142692085vw;
        width: 100%;
        height: fit-content;
        background: white;

        .heighLight {
            margin: 0 auto;
            text-align: center;
            height: 8.23733003708282vh;
            opacity: 1;
            font-weight: bold;
            font-size: 2.2060658579vw;
            //color: #53A3F7;
            font-family: Sarial, sans-serif, "Microsoft Yahei";
            line-height: 4.23733003708282vh;

        }

        .heightLight2 {
            margin: 0 auto;
            text-align: center;
            height: fit-content;
            font-weight: 400;
            color: #2C3E50;
            line-height: 4.94437577255871vh;
            font-size: 1.15vw;
            font-family: Sarial, sans-serif, "Microsoft Yahei";
        }

        .heightLight3 {
            margin: 3vh auto;
            text-align: center;
            height: fit-content;
            font-weight: bold;
            color: #2C3E50;
            line-height: 4.94437577255871vh;
            font-size: 1.5vw;
            font-family: Sarial, sans-serif, "Microsoft Yahei";
        }

        .grid--serviceCapability {
            display: grid;
            grid-template-columns: 1fr;
        }

        .serviceCapabilityList {
            list-style: none;
            padding: 0;
            margin: 0;

            .capability-item {
                margin-bottom: 2vh;

                &:last-child {
                    margin-bottom: 0;
                }
            }

            .capability-title {
                font-weight: bold;
                margin-bottom: 0.5vh;
            }

            .capability-desc {
                padding-left: 1.5em;
            }

            .capability-line {
                line-height: 1.8;
                list-style: none;
            }
        }

        .grid {
            margin-top: 2.78739184177998vh;
            position: relative;

            .card {
                //cursor: pointer;
                width: 100%;
                height: fit-content;
                padding: 0.98887515451174vh 0.69324090121317vw 0.98887515451174vh 0.69324090121317vw;
                opacity: 1;

                .back {
                    background: #eeeeef;
                    border-radius: 9px;
                    display: flex;
                    position: relative;
                    box-shadow: 2px 0 12px 0px #eeeeef;
                    height: 60vh;
                    overflow: hidden;

                    .imgDesign {
                        width: fit-content;
                        height: 100%;
                        opacity: 1;
                        //background-image: url("../../assets/menage6.png");
                        background-position: center;
                        background-size: cover;
                        background-repeat: no-repeat;
                        background-color: transparent;
                    }

                    .titleDesign {
                        padding: 1.5248454883vh 1.5248454883vw 2.5248454883vh 0;
                        margin: auto 1vw auto auto;
                        color: black;
                        width: 50%;
                        float: right;

                        .title1 {
                            margin-top: 4vh;
                            font-size: 1.1709416522vw;
                            font-weight: bold;
                        }

                        .title2 {
                            line-height: 3.3vh;
                            font-size: 0.9vw;
                        }
                    }
                }
            }

            ::v-deep .el-carousel__container {
                height: 65.87268232385661vh !important;
            }

            .el-carousel__item h3 {
                color: white;
                opacity: 0.75;
                margin: 0;
            }

            .el-carousel__item:nth-child(2n) {
                background-color: transparent;
            }

            .el-carousel__item:nth-child(2n+1) {
                background-color: transparent;
            }

            ::v-deep .el-carousel__container {
                position: relative;
                height: 48.83559950556242vh;
            }

            ::v-deep .el-carousel__arrow {
                display: none;
                border: none;
                outline: 0;
                padding: 0;
                margin: 0;
                //cursor: pointer;
                transition: 0.3s;
                border-radius: 0;
                width: 1.15540150202195vw;
                height: 4.32632880098888vh;
                //background: #2168DB;
                color: #fff;
                position: absolute;
                top: 50%;
                //z-index:: 10;
                transform: translateY(-50%);
                text-align: center;
                font-size: 12px;
            }
        }

        .grid1 {
            margin-top: 2.78739184177998vh;
            position: relative;
            display: grid;
            grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);

            .card {
                //cursor: pointer;
                width: 100%;
                height: fit-content;
                padding: 0.98887515451174vh 0.69324090121317vw 0.98887515451174vh 0.69324090121317vw;
                opacity: 1;

                .back {
                    background: #ebf1fd;
                    ;
                    border-radius: 9px;
                    position: relative;
                    border: white 3px solid;
                    box-shadow: 2px 0 12px 0px #c9d9f5;
                    height: fit-content;
                    overflow: hidden;

                    .imgDesign {
                        width: 10vh;
                        height: 10vh;
                        margin: 3vh 1vw 5vh 2vw;
                        opacity: 1;
                        background-position: center;
                        background-size: cover;
                        background-repeat: no-repeat;
                        background-color: transparent;
                    }

                    .title1 {
                        margin-top: 4vh;
                        font-size: 1.1709416522vw;
                        font-weight: bold;
                    }

                    .titleDesign {
                        padding: 0 1.5248454883vw 2.5248454883vh 0;
                        margin: 0 auto;
                        color: black;
                        width: 80%;
                        float: right;

                        .title2 {
                            margin-top: 2vh;
                            line-height: 3.194066749vh;
                            font-size: 1vw;
                        }

                    }

                }
            }

            ::v-deep .el-carousel__container {
                height: 65.87268232385661vh !important;
            }

            .el-carousel__item h3 {
                color: white;
                opacity: 0.75;
                margin: 0;
            }

            .el-carousel__item:nth-child(2n) {
                background-color: transparent;
            }

            .el-carousel__item:nth-child(2n+1) {
                background-color: transparent;
            }

            ::v-deep .el-carousel__container {
                position: relative;
                height: 48.83559950556242vh;
            }

            ::v-deep .el-carousel__arrow {
                display: none;
                border: none;
                outline: 0;
                padding: 0;
                margin: 0;
                //cursor: pointer;
                transition: 0.3s;
                border-radius: 0;
                width: 1.15540150202195vw;
                height: 4.32632880098888vh;
                //background: #2168DB;
                color: #fff;
                position: absolute;
                top: 50%;
                //z-index:: 10;
                transform: translateY(-50%);
                text-align: center;
                font-size: 12px;
            }
        }
    }
    .screenmake8 {
      padding: 5.78739184177998vh 8.09763142692085vw 4.78739184177998vh 8.09763142692085vw;
      width: 100%;
      height: fit-content;
      background: white;
      position: relative;

      .heighLight {
        margin: 0 auto;
        font-weight: bold;
        text-align: center;
        height: 8.23733003708282vh;
        opacity: 1;
        font-size: 2.2060658579vw;
        //color: #53A3F7;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        line-height: 4.23733003708282vh;

      }

      .heightLight2 {
        margin: 0 auto;
        text-align: center;
        height: 13.78739184177998vh;
        font-weight: 400;
        color: #2C3E50;
        line-height: 4.94437577255871vh;

        width: 60.9693818602vw;
        font-size: 1.0287117273vw;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
      }
      .line{
        height: 1vh;
        width: 82%;
        left:50%;
        transform: translateX(-50%);
        border-bottom: dashed black 1px;
        position: absolute;
        top:18.5vh;
        z-index: 1;
      }
      .grid {
        z-index: 2;
        margin-top: 0vh;
        position: relative;
        display: grid;
        grid-template-columns:  repeat(4, 1fr);
        column-gap: 2vw;

        .card {
          //cursor: pointer;
          width: 100%;
          height: fit-content;
          padding: 0.98887515451174vh 0.69324090121317vw 0.98887515451174vh 0.69324090121317vw;
          opacity: 1;

          .back {
            //background: #EFF5FF;
            border-radius: 9px;
            position: relative;
            //box-shadow: 2px 0 12px 0px #c9d9f5;
            height: fit-content;
            overflow: hidden;

            .imgDesign {
              width: 8vh;
              height: 8vh;
              margin:0 auto 2vh auto;
              background-color: white;
              opacity: 1;
            }

            .titleDesign {
              padding: 0;
              width: 100%;
              //margin: 0 0 0 1.5vw;
              color: black;
              float: right;

              .title1 {
                margin-top: 0;
                text-align: center;
                font-size: 1.1709416522vw;
                font-weight: bold;
              }

              .title2 {
                margin-top: 2vh;
                text-align: justify;
                line-height: 3.194066749vh;
                font-size: 0.9vw;
              }

              .title3 {
                display: grid;
                grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);

                margin-top: 2vh;
                line-height: 3.194066749vh;
                font-size: 0.8243212016vw;
              }

            }

          }
        }

        ::v-deep .el-carousel__container {
          height: 65.87268232385661vh !important;
        }

        .el-carousel__item h3 {
          color: white;
          opacity: 0.75;
          margin: 0;
        }

        .el-carousel__item:nth-child(2n) {
          background-color: transparent;
        }

        .el-carousel__item:nth-child(2n+1) {
          background-color: transparent;
        }

        ::v-deep .el-carousel__container {
          position: relative;
          height: 48.83559950556242vh;
        }

        ::v-deep .el-carousel__arrow {
          display: none;
          border: none;
          outline: 0;
          padding: 0;
          margin: 0;
          //cursor: pointer;
          transition: 0.3s;
          border-radius: 0;
          width: 1.15540150202195vw;
          height: 4.32632880098888vh;
          //background: #2168DB;
          color: #fff;
          position: absolute;
          top: 50%;
          //z-index:: 10;
          transform: translateY(-50%);
          text-align: center;
          font-size: 12px;
        }
      }
    }
    .screenmake1 {
      padding: 7vh 11.09763142692085vw 5.78739184177998vh 11.09763142692085vw;
      width: 100%;
      height: fit-content;
      background: white;

      .heighLight {
        margin: 0 auto;
        font-weight: bold;
        text-align: center;
        height: 5.23733003708282vh;
        opacity: 1;
        font-size: 2.2060658579vw;
        //color: #53A3F7;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        line-height: 4.23733003708282vh;

      }

      .heightLight2 {
        margin: 0 auto;
        text-align: center;
        height: 13.78739184177998vh;
        font-weight: 400;
        color: #2C3E50;
        line-height: 4.94437577255871vh;

        width: 60.9693818602vw;
        font-size: 1.0287117273vw;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
      }

      .grid {
        margin-top: 2.78739184177998vh;
        position: relative;

        .card {
          //cursor: pointer;
          width: 100%;
          height: fit-content;
          padding: 0.98887515451174vh 0.69324090121317vw 0.98887515451174vh 0.69324090121317vw;
          opacity: 1;

          .back {
            //background: #EFF5FF;
            border-radius: 9px;
            display: flex;
            position: relative;
            //box-shadow: 2px 0 12px 0px #c9d9f5;
            height: fit-content;
            overflow: hidden;

            .imgDesign {
              width: 100%;
              height: fit-content;
              opacity: 1;
            }

          }
        }

        ::v-deep .el-carousel__container {
          height: 65.87268232385661vh !important;
        }

        .el-carousel__item h3 {
          color: white;
          opacity: 0.75;
          margin: 0;
        }

        .el-carousel__item:nth-child(2n) {
          background-color: transparent;
        }

        .el-carousel__item:nth-child(2n+1) {
          background-color: transparent;
        }

        ::v-deep .el-carousel__container {
          position: relative;
          height: 48.83559950556242vh;
        }

        ::v-deep .el-carousel__arrow {
          display: none;
          border: none;
          outline: 0;
          padding: 0;
          margin: 0;
          //cursor: pointer;
          transition: 0.3s;
          border-radius: 0;
          width: 1.15540150202195vw;
          height: 4.32632880098888vh;
          //background: #2168DB;
          color: #fff;
          position: absolute;
          top: 50%;
          //z-index:: 10;
          transform: translateY(-50%);
          text-align: center;
          font-size: 12px;
        }
      }
    }

    .screenmake5 {
      padding: 5.78739184177998vh 8.09763142692085vw 4.78739184177998vh 8.09763142692085vw;
      width: 100%;
      height: fit-content;
      background: transparent;

      .heighLight {
        margin: 0 auto;
        font-weight: bold;
        text-align: center;
        height: 8.23733003708282vh;
        opacity: 1;
        font-size: 2.2060658579vw;
        //color: #53A3F7;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        line-height: 4.23733003708282vh;

      }

      .heightLight2 {
        margin: 0 auto;
        text-align: center;
        height: 13.78739184177998vh;
        font-weight: 400;
        color: #2C3E50;
        line-height: 4.94437577255871vh;

        width: 60.9693818602vw;
        font-size: 1.0287117273vw;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
      }

      .grid {
        margin-top: 2.78739184177998vh;
        position: relative;
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        column-gap: 0;

        .card {
          //cursor: pointer;
          width: 100%;
          height: fit-content;
          padding: 0.98887515451174vh 0.69324090121317vw 0.98887515451174vh 0.69324090121317vw;
          opacity: 1;

          .back {
            background: #c9d9f5;
            border-radius: 9px;
            //display: flex;
            position: relative;
            border: 1px solid white;
            box-shadow: 2px 0 12px 0px #c9d9f5;
            height: 42vh;
            padding: 2vh 1.5vw 3vh 1.5vw;
            overflow: hidden;

            .imgDesign {
              width: 5vh;
              margin: 0 auto 1vh auto;
              height: 5vh;
              opacity: 1;
            }

            .titleDesign {
              padding: 0;
            //   margin: 0 0 0 1.5vw;
              color: black;
              width: 100%;
              margin-top: 20px;

              .title1 {
                margin: 0 auto;
                text-align: center;
                font-size: 1.1709416522vw;
                font-weight: bold;
              }

              .title2 {
                margin-top: 2vh;

                line-height: 3.194066749vh;
                font-size: 0.9vw;
                margin-left: 1.5vw;
              }

              .title3 {
                display: grid;
                grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
                margin-top: 2vh;
                line-height: 3.194066749vh;
                font-size: 0.8243212016vw;
              }

            }

          }
        }

        ::v-deep .el-carousel__container {
          height: 65.87268232385661vh !important;
        }

        .el-carousel__item h3 {
          color: white;
          opacity: 0.75;
          margin: 0;
        }

        .el-carousel__item:nth-child(2n) {
          background-color: transparent;
        }

        .el-carousel__item:nth-child(2n+1) {
          background-color: transparent;
        }

        ::v-deep .el-carousel__container {
          position: relative;
          height: 48.83559950556242vh;
        }

        ::v-deep .el-carousel__arrow {
          display: none;
          border: none;
          outline: 0;
          padding: 0;
          margin: 0;
          //cursor: pointer;
          transition: 0.3s;
          border-radius: 0;
          width: 1.15540150202195vw;
          height: 4.32632880098888vh;
          //background: #2168DB;
          color: #fff;
          position: absolute;
          top: 50%;
          //z-index:: 10;
          transform: translateY(-50%);
          text-align: center;
          font-size: 12px;
        }
      }
    }

    .screenmake2 {
      padding: 5.78739184177998vh 8.09763142692085vw 4.78739184177998vh 8.09763142692085vw;
      width: 100%;
      height: fit-content;
      //background: transparent;
      background: white;

      .heighLight {
        margin: 0 auto;
        font-weight: bold;
        text-align: center;
        height: 8.23733003708282vh;
        opacity: 1;
        font-size: 2.2060658579vw;
        //color: #53A3F7;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        line-height: 4.23733003708282vh;

      }

      .heightLight2 {
        margin: 0 auto;
        text-align: center;
        height: 13.78739184177998vh;
        font-weight: 400;
        color: #2C3E50;
        line-height: 4.94437577255871vh;
        width: 60.9693818602vw;
        font-size: 1.0287117273vw;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
      }

      .grid {
        margin-top: 2.78739184177998vh;
        position: relative;
        display: grid;
        grid-template-columns:  minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
        column-gap: 0;

        .card {
          //cursor: pointer;
          width: 100%;
          height: fit-content;
          padding: 0.98887515451174vh 0.69324090121317vw 0.98887515451174vh 0.69324090121317vw;
          opacity: 1;

          .back {
            background: white;
            //display: flex;
            position: relative;
            box-shadow: 2px 0 12px 0px #c9d9f5;
            height: 42vh;
            overflow: hidden;

            .imgDesign {
              width: 8vh;
              height: 8vh;
              opacity: 1;
              margin: 3vh auto;
              //background-image: url("../../assets/menage6.png");
            }

            .titleDesign {
              padding: 0;
              margin: 0 0 0 1.5vw;
              color: black;
              width: 85%;
              //float: right;
              .title1 {
                text-align: center;
                margin-top: 0;
                font-size: 1.1vw;
                font-weight: bold;
              }

              .title2 {
                margin-top: 2vh;
                line-height: 3.194066749vh;
                font-size: 0.9vw;
              }

              .title3 {
                display: grid;
                grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);

                margin-top: 2vh;
                line-height: 3.194066749vh;
                font-size: 0.8243212016vw;
              }

            }

          }
        }

        ::v-deep .el-carousel__container {
          height: 65.87268232385661vh !important;
        }

        .el-carousel__item h3 {
          color: white;
          opacity: 0.75;
          margin: 0;
        }

        .el-carousel__item:nth-child(2n) {
          background-color: transparent;
        }

        .el-carousel__item:nth-child(2n+1) {
          background-color: transparent;
        }

        ::v-deep .el-carousel__container {
          position: relative;
          height: 48.83559950556242vh;
        }

        ::v-deep .el-carousel__arrow {
          display: none;
          border: none;
          outline: 0;
          padding: 0;
          margin: 0;
          //cursor: pointer;
          transition: 0.3s;
          border-radius: 0;
          width: 1.15540150202195vw;
          height: 4.32632880098888vh;
          //background: #2168DB;
          color: #fff;
          position: absolute;
          top: 50%;
          //z-index:: 10;
          transform: translateY(-50%);
          text-align: center;
          font-size: 12px;
        }
      }
    }
    .screenmake21{
      padding: 5.78739184177998vh 13.097631vw 4.78739184177998vh 13.097631vw;
      width: 100%;
      height: fit-content;
      background: transparent;

      .heighLight {
        margin: 0 auto;
        font-weight: bold;
        text-align: center;
        height:8.23733003708282vh;
        opacity: 1;
        font-size: 2.2060658579vw;
        //color: #53A3F7;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        line-height: 4.23733003708282vh;

      }

      .heightLight2 {
        margin:0 auto;
        text-align: center;
        height: 13.78739184177998vh;
        font-weight: 400;
        color: #2C3E50;
        line-height: 4.94437577255871vh;

        width: 60.9693818602vw;
        font-size: 1.0287117273vw;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
      }
      .grid{
        margin-top:2.78739184177998vh ;
        position: relative;
        display: grid;
        grid-template-columns:  minmax(0,1fr) minmax(0,1fr) minmax(0,1fr) ;
        column-gap: 1vw;
        .card{
          //cursor: pointer;
          width: 100%;
          height:fit-content ;
          padding:0.98887515451174vh 0.69324090121317vw 0.98887515451174vh 0.69324090121317vw;
          opacity: 1;

          .back{
            //background: #EFF5FF;
            border-radius: 9px;
            display: flex;
            position: relative;
            //box-shadow: 2px 0 12px 0px #c9d9f5;
            height:15vh ;
            overflow:hidden;
            .imgDesign{
              width: 5vh;
              height:5vh;
              opacity: 1;
            }
            .titleDesign{
              padding: 0;
              margin:0 0 0 1.5vw;
              color: black;
              width: 85%;
              float: right;
              .title1{
                margin-top: 0;
                font-size: 1.1709416522vw;
                font-weight: bold;
              }
              .title2{
                margin-top: 2vh;
                text-align: justify;
                line-height: 3.194066749vh;
                font-size: 0.9vw;
              }
              .title3{
                display: grid;
                grid-template-columns: minmax(0,1fr) minmax(0,1fr);

                margin-top: 2vh;
                line-height: 3.194066749vh;
                font-size: 0.8243212016vw;
              }

            }

          }
        }

        ::v-deep .el-carousel__container{
          height: 65.87268232385661vh !important;
        }
        .el-carousel__item h3 {
          color: white;
          opacity: 0.75;
          margin: 0;
        }

        .el-carousel__item:nth-child(2n) {
          background-color: transparent;
        }

        .el-carousel__item:nth-child(2n+1) {
          background-color: transparent;
        }
        ::v-deep .el-carousel__container {
          position: relative;
          height: 48.83559950556242vh;
        }
        ::v-deep .el-carousel__arrow {
          display: none;
          border: none;
          outline: 0;
          padding: 0;
          margin: 0;
          //cursor: pointer;
          transition: 0.3s;
          border-radius: 0;
          width: 1.15540150202195vw;
          height: 4.32632880098888vh;
          //background: #2168DB;
          color: #fff;
          position: absolute;
          top: 50%;
          //z-index:: 10;
          transform: translateY(-50%);
          text-align: center;
          font-size: 12px;
        }
      }
    }
    .screenmake22 {
        padding: 5.78739184177998vh 8.09763142692085vw 5.78739184177998vh 8.09763142692085vw;
        width: 100%;
        height: fit-content;
        background: white;

        .heighLight {
            margin: 0 auto;
            font-weight: bold;
            text-align: center;
            height: 8.23733003708282vh;
            opacity: 1;
            font-size: 2.2060658579vw;
            //color: #53A3F7;
            font-family: Sarial, sans-serif, "Microsoft Yahei";
            line-height: 4.23733003708282vh;

        }

        .heightLight2 {
            margin: 0 auto;
            text-align: center;
            height: 13.78739184177998vh;
            font-weight: 400;
            color: #2C3E50;
            line-height: 4.94437577255871vh;

            width: 60.9693818602vw;
            font-size: 1.0287117273vw;
            font-family: Sarial, sans-serif, "Microsoft Yahei";
        }

        .grid {
            margin-top: 2.78739184177998vh;
            position: relative;
            display: grid;
            grid-template-columns: repeat(4, minmax(0, 1fr));
            column-gap: 1.5vw;

            .card {
                //cursor: pointer;
                width: 100%;
                height: fit-content;
                padding: 0.98887515451174vh 0.69324090121317vw 0.98887515451174vh 0.69324090121317vw;
                opacity: 1;

                .titleDesign {
                    z-index: 999;
                    padding: 0;
                    margin: 0 0 0 1.5vw;
                    color: black;
                    width: 100%;
                    float: right;

                    .title1 {
                        margin: 0 auto;
                        text-align: center;
                        font-size: 1.1709416522vw;
                        font-weight: bold;
                    }

                    .title2 {
                        z-index: 999;
                        margin-top: 2vh;
                        line-height: 3.194066749vh;
                        font-size: 0.9vw;
                    }

                    .title3 {
                        display: grid;
                        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);

                        margin-top: 2vh;
                        line-height: 3.194066749vh;
                        font-size: 0.8243212016vw;
                    }

                }

                .back {
                    border-radius: 9px;
                    //display: flex;
                    position: relative;
                    border: 1px solid white;
                    box-shadow: 2px 0 12px 0px #c9d9f5;
                    background-image: url("../../assets/equipmentBack.png");
                    background-position: center;
                    background-size: cover;
                    background-repeat: no-repeat;
                    background-color: transparent;
                    height: 38vh;
                    padding: 2vh 1.5vw 3vh 1.5vw;
                    overflow: hidden;


                }

                .back1 {
                    border-radius: 9px;
                    //display: flex;
                    position: relative;
                    border: 1px solid white;
                    box-shadow: 2px 0 12px 0px #c9d9f5;
                    background-image: url("../../assets/equipmentBack.png");
                    background-position: center;
                    background-size: cover;
                    background-repeat: no-repeat;
                    background-color: transparent;
                    height: 38vh;
                    padding: 2vh 1.5vw 3vh 1.5vw;
                    overflow: hidden;


                }

                .back2 {
                    border-radius: 9px;
                    //display: flex;
                    position: relative;
                    border: 1px solid white;
                    box-shadow: 2px 0 12px 0px #c9d9f5;
                    background-image: url("../../assets/equipmentBack.png");
                    background-position: center;
                    background-size: cover;
                    background-repeat: no-repeat;
                    background-color: transparent;
                    height: 38vh;
                    padding: 2vh 1.5vw 3vh 1.5vw;
                    overflow: hidden;


                }

                .back3 {
                    border-radius: 9px;
                    //display: flex;
                    position: relative;
                    border: 1px solid white;
                    box-shadow: 2px 0 12px 0px #c9d9f5;
                    background-image: url("../../assets/equipmentBack.png");
                    background-position: center;
                    background-size: cover;
                    background-repeat: no-repeat;
                    background-color: transparent;
                    height: 38vh;
                    padding: 2vh 1.5vw 3vh 1.5vw;
                    overflow: hidden;


                }
            }

            ::v-deep .el-carousel__container {
                height: 65.87268232385661vh !important;
            }

            .el-carousel__item h3 {
                color: white;
                opacity: 0.75;
                margin: 0;
            }

            .el-carousel__item:nth-child(2n) {
                background-color: transparent;
            }

            .el-carousel__item:nth-child(2n+1) {
                background-color: transparent;
            }

            ::v-deep .el-carousel__container {
                position: relative;
                height: 48.83559950556242vh;
            }

            ::v-deep .el-carousel__arrow {
                display: none;
                border: none;
                outline: 0;
                padding: 0;
                margin: 0;
                //cursor: pointer;
                transition: 0.3s;
                border-radius: 0;
                width: 1.15540150202195vw;
                height: 4.32632880098888vh;
                //background: #2168DB;
                color: #fff;
                position: absolute;
                top: 50%;
                //z-index:: 10;
                transform: translateY(-50%);
                text-align: center;
                font-size: 12px;
            }
        }
    }
    .screenmake7 {
      padding: 5.78739184177998vh 13.097631vw 4.78739184177998vh 13.097631vw;
      width: 100%;
      //height: 78vh;
      //height: 50vh;
      height: fit-content;
      background: transparent;
      //background-image: url(@/assets/guanwang100.png);
      //background-image: url("../../assets/guanwang100.png");
      .heighLight {
        margin: 0 auto;
        font-weight: bold;
        text-align: center;
        height: 8.23733003708282vh;
        opacity: 1;
        font-size: 2.2060658579vw;
        //color: #53A3F7;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        line-height: 4.23733003708282vh;
      }
      .heightLight2 {
        margin: 0 auto;
        text-align: center;
        height: 13.78739184177998vh;
        font-weight: 400;
        color: #2C3E50;
        line-height: 4.94437577255871vh;

        width: 60.9693818602vw;
        font-size: 1.0287117273vw;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
      }

      .grid {
        position: relative;
        //display: grid;
        //grid-template-columns:  minmax(0, 1fr);
        //column-gap: 1vh;
        //row-gap: 1vh;

        /* PC 端核心价值：一行两个 */
        &.grid--core-functions {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          column-gap: 1.5vw;
          row-gap: 1.5vh;
        }

        .card {
          //cursor: pointer;
          width: 100%;
          height: fit-content;
          //padding: 0.98887515451174vh 0.69324090121317vw 0.98887515451174vh 0.69324090121317vw;
          opacity: 1;

          /* PC 端核心价值：一个标题下 3 个小点 */
          &.card--core-points .back {
            background: white;
            box-shadow: none;
            padding: 1vh 1vw;
          }
          &.card--core-points .core-point-title {
            font-size: 1.1709416522vw;
            font-weight: bold;
            color: #2c3e50;
            margin-bottom: 0.5em;
          }
          &.card--core-points .core-point-sublist {
            margin: 0 0 0 1em;
            padding-left: 1.2em;
            font-size: 0.9vw;
            line-height: 1.6;
            color: #2c3e50;
            list-style-type: disc;
            list-style-position: outside;
          }

          .back {
            background: rgba(0, 0, 0, 0);
            border-radius: 9px;
            position: relative;
            height: fit-content;
            overflow: hidden;

            .imgDesign {
              width: 100%;
              height: fit-content;
              opacity: 1;
            }

            .titleDesign {
              padding: 0;
              margin: 0.5vh auto;
              color: black;
              width: 100%;
              float: right;

              .title1 {
                margin: 0 1vh;
                text-align:left;
                font-size: 1.1709416522vw;
                font-weight: bold;
              }

              .title2 {
                margin: 2vh 0;
                line-height: 3.194066749vh;
                font-size: 0.9vw;
                text-align: left;
              }


            }

          }
        }

        ::v-deep .el-carousel__container {
          height: 65.87268232385661vh !important;
        }

        .el-carousel__item h3 {
          color: white;
          opacity: 0.75;
          margin: 0;
        }

        .el-carousel__item:nth-child(2n) {
          background-color: transparent;
        }

        .el-carousel__item:nth-child(2n+1) {
          background-color: transparent;
        }

        ::v-deep .el-carousel__container {
          position: relative;
          height: 48.83559950556242vh;
        }

        ::v-deep .el-carousel__arrow {
          display: none;
          border: none;
          outline: 0;
          padding: 0;
          margin: 0;
          //cursor: pointer;
          transition: 0.3s;
          border-radius: 0;
          width: 1.15540150202195vw;
          height: 4.32632880098888vh;
          //background: #2168DB;
          color: #fff;
          position: absolute;
          top: 50%;
          //z-index:: 10;
          transform: translateY(-50%);
          text-align: center;
          font-size: 12px;
        }
      }
    }
    .screenmake3 {
      padding: 5.78739184177998vh 13.097631vw 4.78739184177998vh 13.097631vw;
      width: 100%;
      height: fit-content;
      //height: 50vh;
      //height: fit-content;
      background: transparent;
      //background-image: url(@/assets/guanwang100.png);
      //background-image: url("../../assets/guanwang100.png");
      .heighLight {
        margin: 0 auto;
        font-weight: bold;
        text-align: center;
        height: 8.23733003708282vh;
        opacity: 1;
        font-size: 2.2060658579vw;
        //color: #53A3F7;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        line-height: 4.23733003708282vh;

      }

      .heightLight2 {
        margin: 0 auto;
        text-align: center;
        height: 13.78739184177998vh;
        font-weight: 400;
        color: #2C3E50;
        line-height: 4.94437577255871vh;

        width: 60.9693818602vw;
        font-size: 1.0287117273vw;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
      }

      .grid {
        margin-top: 5.787392vh;
        position: relative;
        display: grid;
        grid-template-columns:  minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
        //grid-template-rows: 9vh 14vh 14vh 14vh;
        column-gap: 0;

        .card {
          //cursor: pointer;
          width: 100%;
          // height: fit-content;
          padding: 0.98887515451174vh 0.69324090121317vw 0.98887515451174vh 0.69324090121317vw;
          opacity: 1;

          .back {
            background: rgba(0, 0, 0, 0);
            border-radius: 9px;
            position: relative;
            height: fit-content;
            overflow: hidden;

            .imgDesign {
              width: 100%;
              height: fit-content;
              opacity: 1;
            }

            .titleDesign {
              padding: 0;
              margin: 3vh auto;
              color: black;
              height: 20vh;
              width: 100%;
              float: right;

              .title1 {
                margin: 0 auto;
                text-align: left;
                font-size: 1.1709416522vw;
                font-weight: bold;
              }

              .title2 {
                margin: 2vh 0;
                width: 69vh;
                line-height: 3.194066749vh;
                font-size: 0.9vw;
              }

              .title3 {
                display: grid;
                grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);

                margin-top: 2vh;
                line-height: 3.194066749vh;
                font-size: 0.8243212016vw;
              }

            }

          }
        }

        ::v-deep .el-carousel__container {
          height: 65.87268232385661vh !important;
        }

        .el-carousel__item h3 {
          color: white;
          opacity: 0.75;
          margin: 0;
        }

        .el-carousel__item:nth-child(2n) {
          background-color: transparent;
        }

        .el-carousel__item:nth-child(2n+1) {
          background-color: transparent;
        }

        ::v-deep .el-carousel__container {
          position: relative;
          height: 48.83559950556242vh;
        }

        ::v-deep .el-carousel__arrow {
          display: none;
          border: none;
          outline: 0;
          padding: 0;
          margin: 0;
          //cursor: pointer;
          transition: 0.3s;
          border-radius: 0;
          width: 1.15540150202195vw;
          height: 4.32632880098888vh;
          //background: #2168DB;
          color: #fff;
          position: absolute;
          top: 50%;
          //z-index:: 10;
          transform: translateY(-50%);
          text-align: center;
          font-size: 12px;
        }
      }
    }

    .screenmake4 {
      padding: 5.78739184177998vh 5.09763142692085vw;
      width: 100%;
      height: fit-content;
      background: #212a3c;

      .heighLight {
        display: flex;
        justify-content: center;
        text-align: center;
        height: 8.23733003708282vh;
        font-size: 2.2060658579vw;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: bold;
        color: white;
        line-height: 4.23733003708282vh;

      }

      .grid {
        margin-top: 2.78739184177998vh;
        position: relative;

        .card {
          //float: right;
          //cursor: pointer;
          width: 90%;
          margin: 0 auto;
          height: fit-content;
          padding: 0 0.69324090121317vw 0 0;
          opacity: 1;
          background: #19202e;

          .back {
            border-radius: 9px;
            display: flex;
            position: relative;
            //box-shadow: 5px 0 14px 0px #D4E4FF;
            height: 58vh;
            overflow: hidden;
            background: #19202e;

            .imgDesign {
              width: fit-content;
              min-width: 60%;
              height: 100%;
              opacity: 1;
              //background-image: url("../../assets/menage6.png");
              background-position: center;
              background-size: cover;
              background-repeat: no-repeat;
              background-color: transparent;
            }

            .titleDesign {
              padding: 1.5248454883vh 1.5248454883vw;
              margin: auto;
              text-align: left;
              color: white;
              width: fit-content;
              float: right;

              .title1 {
                text-align: left;
                font-size: 1.1709416522vw;
              }

              .title2 {
                margin-top: 3vh;
                line-height: 4vh;
                font-size: 0.9243212016vw;

                ::v-deep li {
                  margin-top: 5px;
                }
              ;
              }


            }

          }
        }

        ::v-deep .el-carousel__container {
          height: 60vh !important;

        }

        .el-carousel__item h3 {
          color: white;
          opacity: 0.75;
          margin: 0;
        }

        .el-carousel__item:nth-child(2n) {
          background-color: transparent;
        }

        .el-carousel__item:nth-child(2n+1) {
          background-color: transparent;
        }

        ::v-deep .el-carousel__container {
          position: relative;
          height: 48.83559950556242vh;
        }

        ::v-deep .el-carousel__arrow {
          outline: 10vh;
          padding: 0;
          margin: 0;
          //cursor: pointer;

          border-radius: 50%;
          width: 55px;
          height: 55px;
          background-color: rgba(249, 250, 252, 0.2);
          border: rgba(255, 255, 255, 0.5) 1px solid;
          color: #fff;
          position: absolute;
          top: 50%;
          z-index: 100;
          transform: translateY(-50%);
          text-align: center;
          font-weight: 800;
          font-size: 25px;
        }
      }
    }
  }

  .modal-overlay {
    z-index: 999999999;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal-content {
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
  }

  .large-image {
    max-width: 100%;
    max-height: 80vh;
  }
}

.totalmakeHoleModel {
  background: #ebf1fd;
  overflow-x: hidden;
  width: 100vw;
  height: auto;
  position: relative;

  .makeHole1 {
    //z-index:: 3;
    position: relative;
    width: 100%;
    //height: 100vh;

    .screen1 {
      //z-index:: 3;
      position: relative;
      width: 100%;
      height: 670px;
      padding: 2.84301606922126vh 2.86077411900635vw 2.84301606922126vh 2.86077411900635vw;
      background-image: url("../../assets/bannerModel.png");
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      background-color: transparent;
      /* Add any additional styling as needed */

      .layer2 {
        position: absolute;
        top: 100px;
        left: 9.17157712305026vw;

        .title1 {
          width: 200px;;
          font-size: 3.50606585788562vw;
          font-family: Sarial, sans-serif, "Microsoft Yahei";
          font-weight: 400;
          color: #2f6eff;
        }

        .title2 {
          margin-top: 5px;
          width: 95%;
          height: fit-content;
          font-size: 14px;
          font-family: Sarial, sans-serif, "Microsoft Yahei";
          font-weight: 400;
          color: #4B5A8B;
          line-height: 24px;
        }

        .title4 {
          margin-top: 15px;

          height: 22px;
          font-family: Sarial, sans-serif, "Microsoft Yahei";
          font-weight: 400;
          font-size: 16px;
          color: #2f6dfd;
          line-height: 0px;
          font-style: normal;
          text-transform: none;
        }


      }

      .titlle3 {
        //position: absolute;
        //bottom: 30px;
        //left: 50%;
        //transform: translateX(-60%);
        font-size: 14px;
        font-family: arial, sans-serif, "Microsoft Yahei";
        font-weight: 400;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 9.1px;
        width: fit-content;
        margin: auto;
        padding: 5px 4.6875vw;
        height: 35px;
        color: white;
        background-color: #2f6eff;
        border: 1px solid #2f6eff;
        overflow: hidden;

      }

      //.layer3 {
      //  position: absolute;
      //  top: 5.06798516687268vh;
      //  right: 11.61178509532062vw;
      //  width: 47.42923165800116vw;
      //  height: 72.80593325092707vh;
      //  background-image: url("../assets/GPTplant.png");
      //  background-size: 100% auto;
      //  background-position: center;
      //  background-repeat: no-repeat;
      //  background-color: transparent;
      //  opacity: 1;
      //}
    }

    .screenmake0 {
      //z-index:: 10;
      //left: 10.86077411900635vw;
      width: 100vw;
      height: fit-content;
      padding: 20px 4.6875vw 0 4.6875vw;
      background: white;

      .heighLight {
        text-align: center;
        height: 21px;
        opacity: 1;
        font-size: 21px;
        //color: #53A3F7;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: 700;
        line-height: 26px;
      }

      .heightLight2 {
        padding: 19px 2vw;
        text-align: justify;
        width: fit-content;
        height: fit-content;
        font-size: 14px;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: bold;
        color: #2C3E50;
        line-height: 25px;
      }

    }
    .screenmake111 {
      //z-index:: 10;

      //left: 10.86077411900635vw;
      width: 100vw;
      height: fit-content;
      padding: 20px 4.6875vw;
      background: white;

      .heighLight {
        text-align: center;
        height: 21px;
        opacity: 1;
        font-size: 21px;
        //color: #53A3F7;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: 700;
        line-height: 26px;
      }

      .heightLight2 {
        margin: 19px 2vw;
        text-align: justify;
        width: fit-content;
        height: fit-content;
        font-size: 14px;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: 400;
        color: #2C3E50;
        line-height: 20px;
      }

      .grid {
        position: relative;
        height: fit-content;
        display: grid;
        margin-top: 15px;
        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
        row-gap: 15px;
        column-gap:10px;



        ::v-deep .el-carousel__container {
          height: 65.87268232385661vh !important;
        }

        .el-carousel__item h3 {
          color: white;
          opacity: 0.75;
          margin: 0;
        }

        .el-carousel__item:nth-child(2n) {
          background-color: transparent;
        }

        .el-carousel__item:nth-child(2n+1) {
          background-color: transparent;
        }

        ::v-deep .el-carousel__container {
          position: relative;
          height: 48.83559950556242vh;
        }

        ::v-deep .el-carousel__arrow {
          display: none;
          border: none;
          outline: 0;
          padding: 0;
          margin: 0;
          cursor: pointer;
          transition: 0.3s;
          border-radius: 0;
          width: 1.15540150202195vw;
          height: 4.32632880098888vh;
          //background: #2168DB;
          color: #fff;
          position: absolute;
          top: 50%;
          //z-index:: 10;
          transform: translateY(-50%);
          text-align: center;
          font-size: 12px;
        }
      }
    }
    .screenmake5{
      width: 100vw;
      height: fit-content;
      // margin-top: 10px;
      padding:0  4.6875vw 20px 4.6875vw;
      background: white;
      .heighLight{
        text-align: center;
        height:21px;
        opacity: 1;
        font-size: 21px;
        //color: #53A3F7;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: 700;
        line-height: 26px;
      }
      .heightLight2{
        margin:19px 2vw;
        text-align: justify;
        width: fit-content;
        height: fit-content;
        font-size:14px;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: 400;
        color: #2C3E50;
        line-height: 20px;
      }

      .grid{
        position: relative;
        height: fit-content;
        display: grid;
        margin-top: 10px;
        grid-template-columns: minmax(0,1fr) ;
        column-gap: 5px;
        .card{
          cursor: pointer;
          width: 100%;
          height:fit-content ;
          display: flex;
          padding:0.98887515451174vh 0.69324090121317vw 0.98887515451174vh 0.69324090121317vw;
          opacity: 1;
          .title1{
            margin: 5px auto;
            text-align: left;
            font-size: 16px;
            font-weight: bold;
          }
          .title2{
            margin-top: 5px;

            line-height: 22px;
            font-size: 14px;
          }
          .title3{
            margin-top: 5px;

            line-height: 22px;
            font-size: 14px;
          }
          .titleDesign{
            width: 90%;
            margin: 0 0 0 15px;
          }
          .back{
            background: white;
            border-radius: 9px;
            column-gap: 5px;
            position: relative;
            padding: 0 10px 0 10px;
            height:fit-content;
            display: flex;
            overflow:hidden;
            .imgDesign{
              width: 45px;
              height:45px;
              margin:0 auto 15px auto;
              opacity: 1;
            }


          }

        }

        ::v-deep .el-carousel__container{
          height: 65.87268232385661vh !important;
        }
        .el-carousel__item h3 {
          color: white;
          opacity: 0.75;
          margin: 0;
        }

        .el-carousel__item:nth-child(2n) {
          background-color: transparent;
        }

        .el-carousel__item:nth-child(2n+1) {
          background-color: transparent;
        }
        ::v-deep .el-carousel__container {
          position: relative;
          height: 48.83559950556242vh;
        }
        ::v-deep .el-carousel__arrow {
          display: none;
          border: none;
          outline: 0;
          padding: 0;
          margin: 0;
          cursor: pointer;
          transition: 0.3s;
          border-radius: 0;
          width: 1.15540150202195vw;
          height: 4.32632880098888vh;
          //background: #2168DB;
          color: #fff;
          position: absolute;
          top: 50%;
          //z-index:: 10;
          transform: translateY(-50%);
          text-align: center;
          font-size: 12px;
        }
      }
    }
    .screenmake1 {
      width: 100vw;
      height: fit-content;
      padding: 5px 4.6875vw 20px 4.6875vw;
      background: transparent;

      .heighLight {
        text-align: center;
        height: 21px;
        opacity: 1;
        font-size: 21px;
        //color: #53A3F7;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: 700;
        line-height: 26px;
      }

      .heightLight2 {
        margin: 19px 2vw;
        text-align: justify;
        width: fit-content;
        height: fit-content;
        font-size: 14px;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: 400;
        color: #2C3E50;
        line-height: 20px;
      }

      .grid {
        position: relative;
        height: fit-content;

        .card {
          cursor: pointer;
          width: 100%;
          height: fit-content;
          padding: 0.98887515451174vh 0.69324090121317vw 0.98887515451174vh 0.69324090121317vw;
          opacity: 1;

          .titleDesign {
            margin-top: 20px;
          }

          .back {
            background: white;
            border-radius: 9px;
            column-gap: 5px;
            position: relative;
            height: fit-content;
            margin-top: 15px;
            overflow: hidden;

            .imgDesign {
              width: 100%;
              //border: #666666 1px solid;
              height: fit-content;
              opacity: 1;

            }


          }

        }

        ::v-deep .el-carousel__container {
          height: 65.87268232385661vh !important;
        }

        .el-carousel__item h3 {
          color: white;
          opacity: 0.75;
          margin: 0;
        }

        .el-carousel__item:nth-child(2n) {
          background-color: transparent;
        }

        .el-carousel__item:nth-child(2n+1) {
          background-color: transparent;
        }

        ::v-deep .el-carousel__container {
          position: relative;
          height: 48.83559950556242vh;
        }

        ::v-deep .el-carousel__arrow {
          display: none;
          border: none;
          outline: 0;
          padding: 0;
          margin: 0;
          cursor: pointer;
          transition: 0.3s;
          border-radius: 0;
          width: 1.15540150202195vw;
          height: 4.32632880098888vh;
          //background: #2168DB;
          color: #fff;
          position: absolute;
          top: 50%;
          //z-index:: 10;
          transform: translateY(-50%);
          text-align: center;
          font-size: 12px;
        }
      }
    }

    .screenmake2 {
      //z-index:: 10;

      //left: 10.86077411900635vw;
      width: 100vw;
      height: fit-content;
      padding: 20px 4.6875vw;
      background: transparent;

      .heighLight {
        text-align: center;
        height: 21px;
        opacity: 1;
        font-size: 21px;
        //color: #53A3F7;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: 700;
        line-height: 26px;
      }

      .heightLight2 {
        margin: 19px 2vw;
        text-align: justify;
        width: fit-content;
        height: fit-content;
        font-size: 14px;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: 400;
        color: #2C3E50;
        line-height: 20px;
      }

      .grid {
        position: relative;
        height: fit-content;
        display: grid;
        margin-top: 10px;
        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
        column-gap: 5px;

        .card {
          cursor: pointer;
          width: 100%;
          height: 100%;
          padding: 0.98887515451174vh 0.69324090121317vw 0.98887515451174vh 0.69324090121317vw;
          opacity: 1;

          .title1 {
            margin: 5px auto;
            text-align: center;
            font-size: 16px;
            font-weight: bold;
          }

          .title2 {
            margin-top: 5px;

            line-height: 22px;
            font-size: 14px;
          }

          .title3 {
            margin-top: 5px;

            line-height: 22px;
            font-size: 14px;
          }

          .titleDesign {
            margin-top: 10px;
          }

          .back {
            background: white;
            border-radius: 9px;
            column-gap: 5px;
            position: relative;
            padding: 15px 10px;
            height: 100%;
            margin-top: 5px;
            overflow: hidden;

            .imgDesign {
              width: 45px;
              height: 45px;
              margin: 0 auto 15px auto;
              opacity: 1;
            }


          }

        }

        ::v-deep .el-carousel__container {
          height: 65.87268232385661vh !important;
        }

        .el-carousel__item h3 {
          color: white;
          opacity: 0.75;
          margin: 0;
        }

        .el-carousel__item:nth-child(2n) {
          background-color: transparent;
        }

        .el-carousel__item:nth-child(2n+1) {
          background-color: transparent;
        }

        ::v-deep .el-carousel__container {
          position: relative;
          height: 48.83559950556242vh;
        }

        ::v-deep .el-carousel__arrow {
          display: none;
          border: none;
          outline: 0;
          padding: 0;
          margin: 0;
          cursor: pointer;
          transition: 0.3s;
          border-radius: 0;
          width: 1.15540150202195vw;
          height: 4.32632880098888vh;
          //background: #2168DB;
          color: #fff;
          position: absolute;
          top: 50%;
          //z-index:: 10;
          transform: translateY(-50%);
          text-align: center;
          font-size: 12px;
        }
      }
    }

    .screenmake22 {
        padding: 20px 4.6875vw;
        width: 100%;
        height: fit-content;
        background: white;

        .heighLight {
            margin: 0 auto;
            font-weight: bold;
            text-align: center;
            height: 8.23733003708282vh;
            opacity: 1;
            font-size: 21px;
            //color: #53A3F7;
            font-family: Sarial, sans-serif, "Microsoft Yahei";
            line-height: 4.23733003708282vh;

        }
        .grid {
            position: relative;
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 4vw;

            .card {
                //cursor: pointer;
                width: 100%;
                height: fit-content;
                opacity: 1;
                .back {
                    border-radius: 9px;
                    //display: flex;
                    position: relative;
                    border: 1px solid white;
                    box-shadow: 2px 0 12px 0px #c9d9f5;
                    background-image: url("../../assets/equipmentBack.png");
                    background-position: center;
                    background-size: cover;
                    background-repeat: no-repeat;
                    background-color: transparent;
                    height: 28vh;
                    padding: 15px 10px;
                    overflow: hidden;

                    .title1{
                        font-size: 16px;
                        font-weight: bold;
                    }
                    .title2{
                        margin-top: 5px;
                        line-height: 22px;
                        font-size: 12px;
                        margin-left: 12px;
                    }

                }

                .back1 {
                    border-radius: 9px;
                    //display: flex;
                    position: relative;
                    border: 1px solid white;
                    box-shadow: 2px 0 12px 0px #c9d9f5;
                    background-image: url("../../assets/equipmentBack.png");
                    background-position: center;
                    background-size: cover;
                    background-repeat: no-repeat;
                    background-color: transparent;
                    height: 38vh;
                    padding: 2vh 1.5vw 3vh 1.5vw;
                    overflow: hidden;


                }

                .back2 {
                    border-radius: 9px;
                    //display: flex;
                    position: relative;
                    border: 1px solid white;
                    box-shadow: 2px 0 12px 0px #c9d9f5;
                    background-image: url("../../assets/equipmentBack.png");
                    background-position: center;
                    background-size: cover;
                    background-repeat: no-repeat;
                    background-color: transparent;
                    height: 38vh;
                    padding: 2vh 1.5vw 3vh 1.5vw;
                    overflow: hidden;


                }

                .back3 {
                    border-radius: 9px;
                    //display: flex;
                    position: relative;
                    border: 1px solid white;
                    box-shadow: 2px 0 12px 0px #c9d9f5;
                    background-image: url("../../assets/equipmentBack.png");
                    background-position: center;
                    background-size: cover;
                    background-repeat: no-repeat;
                    background-color: transparent;
                    height: 38vh;
                    padding: 2vh 1.5vw 3vh 1.5vw;
                    overflow: hidden;


                }
            }

            ::v-deep .el-carousel__container {
                height: 65.87268232385661vh !important;
            }

            .el-carousel__item h3 {
                color: white;
                opacity: 0.75;
                margin: 0;
            }

            .el-carousel__item:nth-child(2n) {
                background-color: transparent;
            }

            .el-carousel__item:nth-child(2n+1) {
                background-color: transparent;
            }

            ::v-deep .el-carousel__container {
                position: relative;
                height: 48.83559950556242vh;
            }

            ::v-deep .el-carousel__arrow {
                display: none;
                border: none;
                outline: 0;
                padding: 0;
                margin: 0;
                //cursor: pointer;
                transition: 0.3s;
                border-radius: 0;
                width: 1.15540150202195vw;
                height: 4.32632880098888vh;
                //background: #2168DB;
                color: #fff;
                position: absolute;
                top: 50%;
                //z-index:: 10;
                transform: translateY(-50%);
                text-align: center;
                font-size: 12px;
            }
        }
    }

    .screenmake3 {
      //z-index:: 10;

      //left: 10.86077411900635vw;
      width: 100vw;
      height: fit-content;
      padding: 20px 4.6875vw;
      background: white;

      .heighLight {
        text-align: center;
        height: 21px;
        opacity: 1;
        font-size: 21px;
        //color: #53A3F7;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: 700;
        line-height: 26px;
      }

      .heightLight2 {
        margin: 19px 2vw;
        text-align: justify;
        width: fit-content;
        height: fit-content;
        font-size: 14px;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: 400;
        color: #2C3E50;
        line-height: 20px;
      }

      .grid {
        position: relative;
        height: fit-content;
        margin-top: 10px;

        .card {
          cursor: pointer;
          width: 100%;
          height: fit-content;
          padding: 0.98887515451174vh 0.69324090121317vw 0.98887515451174vh 0.69324090121317vw;
          opacity: 1;

          .title1 {
            margin: 5px auto;
            text-align: center;
            font-size: 16px;
            font-weight: bold;
          }

          .title2 {
            margin: 15px auto;
            width: 45vh;
            line-height: 22px;
            font-size: 14px;
          }

          .titleDesign {

            margin: 10px 10px;
          }

          .back {
            margin-top: 10px;
            background-color: #ebf1fd;
            padding: 0 0 10px 0;
            border-radius: 9px;
            column-gap: 5px;
            position: relative;
            height: fit-content;
            overflow: hidden;

            .imgDesign {
              width: 100%;
              height: 100%;
              opacity: 1;

            }


          }

        }

        ::v-deep .el-carousel__container {
          height: 65.87268232385661vh !important;
        }

        .el-carousel__item h3 {
          color: white;
          opacity: 0.75;
          margin: 0;
        }

        .el-carousel__item:nth-child(2n) {
          background-color: transparent;
        }

        .el-carousel__item:nth-child(2n+1) {
          background-color: transparent;
        }

        ::v-deep .el-carousel__container {
          position: relative;
          height: 48.83559950556242vh;
        }

        ::v-deep .el-carousel__arrow {
          display: none;
          border: none;
          outline: 0;
          padding: 0;
          margin: 0;
          cursor: pointer;
          transition: 0.3s;
          border-radius: 0;
          width: 1.15540150202195vw;
          height: 4.32632880098888vh;
          //background: #2168DB;
          color: #fff;
          position: absolute;
          top: 50%;
          //z-index:: 10;
          transform: translateY(-50%);
          text-align: center;
          font-size: 12px;
        }
      }
    }

    .screenmake4 {
      //left: 10.86077411900635vw;
      width: 100vw;
      height: fit-content;

      padding: 20px 4.6875vw;
      background: black;

      .heighLight {
        text-align: center;
        height: 21px;
        opacity: 1;
        font-size: 21px;
        color: white;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: 700;
        line-height: 26px;
      }

      .heightLight2 {
        margin: 19px 2vw;
        text-align: justify;
        width: fit-content;
        height: fit-content;
        font-size: 14px;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: 400;
        color: #2C3E50;
        line-height: 20px;
      }

      .grid {
        margin-top: 2.78739184177998vh;
        position: relative;

        .arrowButtonleft {
          border: none;
          outline: 0;
          padding: 0;
          margin: 0;
          cursor: pointer;
          transition: 0.3s;
          border-radius: 0;
          width: 1.15540150202195vw;
          height: 4.32632880098888vh;
          background: white;
          color: black;
          position: absolute;
          top: 50%;
          left: -55px;
          //z-index:: 10;
          transform: translateY(-50%);
          text-align: center;
          font-size: 1.2432120161756vw;
          font-weight: bold;
        }

        .arrowButtonright {
          border: none;
          outline: 0;
          padding: 0;
          margin: 0;
          cursor: pointer;
          transition: 0.3s;
          border-radius: 0;
          width: 1.15540150202195vw;
          height: 4.32632880098888vh;
          background: white;
          color: black;
          position: absolute;
          top: 50%;
          right: -55px;
          //z-index:: 10;
          transform: translateY(-50%);
          text-align: center;
          font-size: 1.2432120161756vw;
          font-weight: bold;
        }

        .card {
          cursor: pointer;
          width: 98%;
          margin: 0 auto;
          height: fit-content;
          padding: 0 0.69324090121317vw 0 0;
          opacity: 1;
          background: #19202e;

          .back {
            border-radius: 9px;
            position: relative;
            //box-shadow: 5px 0 14px 0px #D4E4FF;
            height: fit-content;
            overflow: hidden;
            background: #19202e;

            .imgDesign {
              width: 100%;
              height: 194px;
              opacity: 1;

            }

            .titleDesign {
              padding: 15px 20px 25px 20px;
              color: white;
              width: 100%;
              float: right;

              .title1 {
                margin-top: 15px;
                font-size: 16px;
              }

              .title2 {
                margin-top: 15px;
                line-height: 22px;
                font-size: 14px;

                ::v-deep li {
                  margin-top: 5px;
                }
              ;
              }


            }

          }
        }

        ::v-deep .el-carousel__container {
          height: 340px !important;

        }

        .el-carousel__item h3 {
          color: white;
          opacity: 0.75;
          margin: 0;
        }

        .el-carousel__item:nth-child(2n) {
          background-color: transparent;
        }

        .el-carousel__item:nth-child(2n+1) {
          background-color: transparent;
        }

        ::v-deep .el-carousel__arrow {
          display: block;
          //border: 1px solid white;
          outline: -5px;
          padding: 0;
          margin: -65px -10px;
          cursor: pointer;

          border-radius: 0;
          width: 25px;
          height: 48px;
          background: rgba(245, 246, 250, 0.8);
          color: #131313;
          position: absolute;
          top: 50%;
          //z-index:: 100;
          transform: translateY(-50%);
          text-align: center;
          font-size: 14px;
        }
      }
    }

    .screenmake6 {
      //z-index:: 10;

      //left: 10.86077411900635vw;
      width: 100vw;
      height: fit-content;
      padding: 20px 4.6875vw;
      background: white;

      .heighLight {
        text-align: center;
        height: 21px;
        opacity: 1;
        font-size: 21px;
        //color: #53A3F7;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: 700;
        line-height: 26px;
      }

      .heightLight2 {
        margin: 19px 2vw;
        text-align: justify;
        width: fit-content;
        height: fit-content;
        font-size: 14px;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: 400;
        color: #2C3E50;
        line-height: 25px;
      }

      .grid {
        position: relative;
        height: fit-content;

        .card {
          cursor: pointer;
          width: 100%;
          height: fit-content;
          padding: 0.98887515451174vh 0.69324090121317vw 0.98887515451174vh 0.69324090121317vw;
          opacity: 1;

          .title1 {
            margin-top: 5px;
            font-size: 16px;
            font-weight: bold;
            text-align: left;
            margin: 5px 20px;
          }

          .title2 {

            width: auto;
            margin: 0px 25px;
            line-height: 22px;
            font-size: 14px;
          }

          .titleDesign {
            margin-top: 20px;
          }

          .title3 {
            margin-top: 5px;
            display: grid;
            grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
            line-height: 22px;
            font-size: 14px;
          }

          /* 核心价值：一个标题下 3 个小点 */
          &.card--core-points{
            
            .core-points-list {
              list-style: none;
              padding: 0;
              margin: 0;
              display: grid;
                grid-template-columns: repeat(2, 1fr);
                gap: 10px;
            }
            .core-point-item {
                background-color: #EFF5FF;
              padding-left: 0;
              padding: 10px;
                border-radius: 9px;
            }
            .core-point-title {
              font-size: 16px;
              font-weight: bold;
              color: #2c3e50;
              margin-bottom: 0.5em;
            }
            .core-point-sublist {
              margin: 0 0 0 .4em;
              padding-left: 1.2em;
              font-size: 14px;
              line-height: 1.6;
              color: #2c3e50;
              list-style-type: disc;
              list-style-position: outside;
            }
          }

          .back {
            margin-top: 15px;
            height: fit-content;
            background: #EFF5FF;
            position: relative;
            box-shadow: 2px 0 12px 0px #c9d9f5;
            //height:580px ;
            overflow: hidden;

            .imgDesign {
              width: 100%;
              height: 195px;
              opacity: 1;
              background-position: center;
              background-size: cover;
              background-repeat: no-repeat;
              background-color: transparent;
            }


          }

        }

        ::v-deep .el-carousel__container {
          height: 65.87268232385661vh !important;
        }

        .el-carousel__item h3 {
          color: white;
          opacity: 0.75;
          margin: 0;
        }

        .el-carousel__item:nth-child(2n) {
          background-color: transparent;
        }

        .el-carousel__item:nth-child(2n+1) {
          background-color: transparent;
        }

        ::v-deep .el-carousel__container {
          position: relative;
          height: 48.83559950556242vh;
        }

        ::v-deep .el-carousel__arrow {
          display: none;
          border: none;
          outline: 0;
          padding: 0;
          margin: 0;
          cursor: pointer;
          transition: 0.3s;
          border-radius: 0;
          width: 1.15540150202195vw;
          height: 4.32632880098888vh;
          //background: #2168DB;
          color: #fff;
          position: absolute;
          top: 50%;
          //z-index:: 10;
          transform: translateY(-50%);
          text-align: center;
          font-size: 12px;
        }
      }

      .grid1 {
        position: relative;
        height: fit-content;
        display: grid;
        margin-top: 25px;
        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
        column-gap: 0;
        row-gap: 15px;

        .card {
          border-radius: 9px;
          cursor: pointer;
          width: 100%;
          height: 185px;
          background-color: white;
          padding: 5px 10px;
          opacity: 1;

          .title1 {
            height: 45px;
            justify-content: center;
            align-items: center;
            display: flex;
            font-size: 16px;
            font-weight: bold;
          }

          .title2 {
            margin: 0 5px;
            text-align: justify;
            line-height: 22px;
            font-size: 14px;
          }

          .titleDesign {
            margin-top: 10px;
          }

          .title3 {
            margin-top: 5px;
            display: grid;
            grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
            line-height: 22px;
            font-size: 14px;
          }

          .back {
            margin-top: 15px;
            border-radius: 9px;
            position: relative;
            //height:580px ;
            overflow: hidden;

            .imgDesign {
              width: 40px;
              height: 38px;
              margin: 0 10px 0 5px;
              opacity: 1;
              background-position: center;
              background-size: contain;
              background-repeat: no-repeat;
              background-color: transparent;
            }


          }

        }

        ::v-deep .el-carousel__container {
          height: 65.87268232385661vh !important;
        }

        .el-carousel__item h3 {
          color: white;
          opacity: 0.75;
          margin: 0;
        }

        .el-carousel__item:nth-child(2n) {
          background-color: transparent;
        }

        .el-carousel__item:nth-child(2n+1) {
          background-color: transparent;
        }

        ::v-deep .el-carousel__container {
          position: relative;
          height: 48.83559950556242vh;
        }

        ::v-deep .el-carousel__arrow {
          display: none;
          border: none;
          outline: 0;
          padding: 0;
          margin: 0;
          cursor: pointer;
          transition: 0.3s;
          border-radius: 0;
          width: 1.15540150202195vw;
          height: 4.32632880098888vh;
          //background: #2168DB;
          color: #fff;
          position: absolute;
          top: 50%;
          //z-index:: 10;
          transform: translateY(-50%);
          text-align: center;
          font-size: 12px;
        }
      }
    }
  }

}
</style>
